import { z } from "zod";
import { layerSnapshotSchema } from "~/components/map/registry/layerSnapshot";
import { PROPERTY_LAYER_REGISTRY } from "./-components/propertyLayerRegistry";

export const propertyTabSchema = z.enum([
  "overblik",
  "bbr",
  "ejerforhold",
  "handel",
  "dokumenter",
  "naeromraade",
]);

export type PropertyTab = z.infer<typeof propertyTabSchema>;

export const propertySelectionSchema = z.object({
  streetNumberId: z.guid(),
  placeId: z.guid().optional(),
});

export const propertySearchSchema = propertySelectionSchema
  .pick({ placeId: true })
  .extend({
    tab: propertyTabSchema.default("overblik").catch("overblik"),
    mapLayers: layerSnapshotSchema(PROPERTY_LAYER_REGISTRY.layers),
  });

export const bfeNumberSchema = z
  .string()
  .regex(/^[1-9]\d*$/)
  .refine((value) => Number.isSafeInteger(Number(value)))
  .brand<"BfeNumber">();

export const propertyParamsSchema = z.object({ bfeNumber: bfeNumberSchema });

export const resolvedPropertySearchSchema = propertySearchSchema.extend({
  accessAddressId: propertySelectionSchema.shape.streetNumberId.optional(),
});

export const resolvedPropertySchema = resolvedPropertySearchSchema.extend(
  propertyParamsSchema.shape,
);

export type PropertySelection = z.infer<typeof propertySelectionSchema>;
export type ResolvedProperty = z.infer<typeof resolvedPropertySchema>;
